import { Component, OnInit, ViewChild } from '@angular/core';

import { ResourceService } from '@kaiser-software/chassis-resource';
import { ChassisEntityCollectionServiceBase } from '@kaiser-software/chassis-resource/src/services/chassis-entity-collection-service-base';
import { EntityAuthorizations, IAbstractEntity } from '@kaiser-software/chassis-resource/src/interfaces';

import { RouteService } from '../../../routing/services/route.service';
import { ToolbarService } from '../../../layouts/toolbar/services/toolbar.service';
import { button, BUTTONS } from '../../../support/buttons';
import { ResourceFormComponent } from '../../components/resource-form/resource-form.component';

@Component({
    selector: 'create-page',
    templateUrl: 'create.page.html'
})

export class CreatePage implements OnInit {
    @ViewChild(ResourceFormComponent) resourceFormComponent: ResourceFormComponent;

    protected entityService: ChassisEntityCollectionServiceBase<IAbstractEntity>;

    public static = false;

    public entity: any = {};

    public entityName: string;

    constructor(
        protected resourceService: ResourceService,
        protected routeService: RouteService,
        protected toolbarService: ToolbarService,
    ) {
        this.resourceService
            .getResourceFromUrl(this.routeService.currentUrl)
            .subscribe(service => {
                this.entityService = service;

                this.entityName = service.entityName;

                this.addToolbarButtons();
            });
    }

    ngOnInit() {
    }

    protected addToolbarButtons() {
        this.toolbarService.add(button(BUTTONS.SAVE, {
            callback: () => {
                this.saveEntity();
            },
            authorized: () => {
                let mode: EntityAuthorizations = 'create';

                if (this.entity.hasOwnProperty('_id')) {
                    mode = 'update';
                }

                return this.entityService.authorizedTo(mode);
            }
        }));
    }

    protected saveEntity() {
        console.log('Create page | Save');

        this.resourceFormComponent.saveEntity();
    }

    public onSubmit(event) {
        console.log('Create page | On submit: ', event);

        event.subscribe(result => {
            console.log('Result: ', result);
        }, error => {
            console.log('Error: ', error);
        })
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/pages/create/create.page.ts